import React, { useState, useEffect } from "react";
import { main_link } from "../Connection/Connection";
import useFetch from "../Fetch_Folder/useFetch";

import AddBeardPriceModel from "../Modals/AddBeardPriceModel";
import AddFacePriceModel from "../Modals/AddFacePriceModel";
import AddhairCutPriceModel from "../Modals/AddhairCutPriceModel";

import { FilterMatchMode, FilterService } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import EditCuts from "../Modals/EditCuts";
import Spinner from "react-bootstrap/Spinner";
import { Tag } from "primereact/tag";
//
const Cuts = () => {
  const user = JSON.parse(sessionStorage.getItem("user-data"));
  const user_id = user["encrypted_id"];

  const [counter, setCounter] = useState(0);

  const {
    error,
    isLoading,
    data: cuts,
  } = useFetch(`${main_link}cutsIndex?user_id=${user_id}`, counter);

  const hair = cuts ? cuts.filter((cut) => cut.type === "Hair") : [];
  const face = cuts ? cuts.filter((cut) => cut.type == "Face") : [];
  const beard = cuts ? cuts.filter((cut) => cut.type == "Beard") : [];

  const [filters, setFilters] = useState({
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    indexH: { value: null, matchMode: FilterMatchMode.CONTAINS }, // tar2em lal table
    indexB: { value: null, matchMode: FilterMatchMode.CONTAINS }, // tar2em lal table
    indexF: { value: null, matchMode: FilterMatchMode.CONTAINS }, // tar2em lal table
    price: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_by_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_at_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [showEdit, setShowEdit] = useState(false);
  const [cutDetails, setCutDetails] = useState([]);

  const editTemplate = (rowData) => {
    return (
      <Button
        type="button"
        icon="nav-icon fas fa-edit"
        style={{ borderRadius: "50px" }}
        onClick={() => {
          setShowEdit(true);
          setCutDetails(rowData);
        }}
      />
    );
  };

  const cutStatus = (rowData) => {
    if (rowData.isRemoved === "1") {
      return <Tag value="Hidden" severity="danger" />;
    }
    return <Tag value="Shown" severity="error" />;
  };

  return (
    <>
      <EditCuts
        showEdit={showEdit}
        setShowEdit={setShowEdit}
        cutDetails={cutDetails}
        counter={counter}
        setCounter={setCounter}
      />
      <AddFacePriceModel counter={counter} setCounter={setCounter} />
      <AddBeardPriceModel counter={counter} setCounter={setCounter} />
      <AddhairCutPriceModel counter={counter} setCounter={setCounter} />
      <div>
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Cuts Price</h1>
                </div>
              </div>
            </div>
          </section>
          {/* Hair Beard */}
          <section className="content">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  Hair Cut{" "}
                  {isLoading && (
                    <Spinner
                      size="sm"
                      animation="border"
                      role="status"
                    ></Spinner>
                  )}
                </h3>
                <div className="card-tools">
                  <i
                    className="fas fa-plus-circle fa-2x icon"
                    data-toggle="modal"
                    data-target="#hair-cut"
                  ></i>
                </div>
              </div>

              <DataTable
                value={hair}
                sortMode="multiple"
                tableStyle={{ minWidth: "50rem" }}
                paginator
                rows={10}
                dataKey="index"
                filters={filters}
                filterDisplay="row"
                loading={isLoading}
                scrollable
                removableSort
                stripedRows
              >
                <Column
                  field="indexH"
                  header="ID"
                  sortable
                  style={{ width: "15%" }}
                  filter
                  filterPlaceholder="Search by ID"
                ></Column>
                <Column
                  field="name"
                  header="Name"
                  sortable
                  style={{ width: "15%" }}
                  filter
                  filterPlaceholder="Search by name"
                ></Column>
                <Column
                  field="price"
                  header="Price"
                  sortable
                  style={{ width: "25%" }}
                  filter
                  filterPlaceholder="Search by created by"
                ></Column>
                <Column
                  field="created_by_name"
                  header="Created By"
                  sortable
                  style={{ width: "25%" }}
                  filter
                  filterPlaceholder="Search by created by"
                ></Column>
                <Column
                  field="created_at_at"
                  header="Created AT"
                  sortable
                  style={{ width: "25%" }}
                  filter
                  filterPlaceholder="Search by created by"
                ></Column>

                <Column
                  field="status"
                  header="Status"
                  body={cutStatus}
                  filterPlaceholder="Filter"
                ></Column>

                <Column header="Edit" body={editTemplate}></Column>
              </DataTable>
            </div>
          </section>
          {/* Beard Beard  */}
          <section className="content">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  Beard Cut{" "}
                  {isLoading && (
                    <Spinner
                      size="sm"
                      animation="border"
                      role="status"
                    ></Spinner>
                  )}
                </h3>
                <div className="card-tools">
                  <i
                    className="fas fa-plus-circle fa-2x icon"
                    data-toggle="modal"
                    data-target="#beard-cut"
                  ></i>
                </div>
              </div>
              <div className="card-body">
                <DataTable
                  value={beard}
                  sortMode="multiple"
                  tableStyle={{ minWidth: "50rem" }}
                  paginator
                  rows={10}
                  dataKey="index"
                  filters={filters}
                  filterDisplay="row"
                  loading={isLoading}
                  scrollable
                  removableSort
                  stripedRows
                >
                  <Column
                    field="indexB"
                    header="ID"
                    sortable
                    style={{ width: "15%" }}
                    filter
                    filterPlaceholder="Search by name"
                  ></Column>
                  <Column
                    field="name"
                    header="Name"
                    sortable
                    style={{ width: "15%" }}
                    filter
                    filterPlaceholder="Search by name"
                  ></Column>
                  <Column
                    field="price"
                    header="Price"
                    sortable
                    style={{ width: "25%" }}
                    filter
                    filterPlaceholder="Search by created by"
                  ></Column>
                  <Column
                    field="created_by_name"
                    header="Created By"
                    sortable
                    style={{ width: "25%" }}
                    filter
                    filterPlaceholder="Search by created by"
                  ></Column>
                  <Column
                    field="created_at_at"
                    header="Created AT"
                    sortable
                    style={{ width: "25%" }}
                    filter
                    filterPlaceholder="Search by created by"
                  ></Column>
                  <Column
                    field="status"
                    header="Status"
                    body={cutStatus}
                    style={{ minWidth: "100px" }}
                  ></Column>

                  <Column header="Edit" sortable body={editTemplate}></Column>
                </DataTable>
              </div>
            </div>
          </section>
          {/* Face Section */}
          <section className="content">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  Face Section{" "}
                  {isLoading && (
                    <Spinner
                      size="sm"
                      animation="border"
                      role="status"
                    ></Spinner>
                  )}
                </h3>
                <div className="card-tools">
                  <i
                    className="fas fa-plus-circle fa-2x icon"
                    data-toggle="modal"
                    data-target="#face-cut"
                  ></i>
                </div>
              </div>
              <div className="card-body">
                {" "}
                <DataTable
                  value={face}
                  sortMode="multiple"
                  tableStyle={{ minWidth: "50rem" }}
                  paginator
                  rows={10}
                  dataKey="index"
                  filters={filters}
                  filterDisplay="row"
                  loading={isLoading}
                  scrollable
                  removableSort
                  stripedRows
                >
                  <Column
                    field="indexF"
                    header="ID"
                    sortable
                    style={{ width: "15%" }}
                    filter
                    filterPlaceholder="Search by ID"
                  ></Column>
                  <Column
                    field="name"
                    header="Name"
                    sortable
                    style={{ width: "15%" }}
                    filter
                    filterPlaceholder="Search by name"
                  ></Column>
                  <Column
                    field="price"
                    header="Price"
                    sortable
                    style={{ width: "25%" }}
                    filter
                    filterPlaceholder="Search by created by"
                  ></Column>
                  <Column
                    field="created_by_name"
                    header="Created By"
                    sortable
                    style={{ width: "25%" }}
                    filter
                    filterPlaceholder="Search by created by"
                  ></Column>
                  <Column
                    field="created_at_at"
                    header="Created AT"
                    sortable
                    style={{ width: "25%" }}
                    filter
                    filterPlaceholder="Search by created by"
                  ></Column>
                  <Column
                    field="status"
                    header="Status"
                    body={cutStatus}
                    style={{ minWidth: "100px" }}
                  ></Column>
                  <Column header="Edit" sortable body={editTemplate}></Column>
                </DataTable>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Cuts;
